
<script>
  export let id = null
  /* in px */
  export let height = 500
  export let text = ""
</script>

<a href="{window.configs.baseUrl}image/{id}">
  <img src="{window.configs.baseUrl}image/{id}" alt="Image with an ad id of {id}" class="ad" height="{height}px">
</a>